import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { Observable } from "rxjs/Observable";
import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { DefaultTask } from "./default-task.model";

export class DefaultTaskApiFacade extends AccountObjectApiFacade<DefaultTask> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<DefaultTask> {
        return this.GET(`/accounts/${accountId}/defaulttasks/${id}`, options)
            .map(object => new DefaultTask(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<DefaultTask>> {
        return this.CGET(`/accounts/${accountId}/defaulttasks`, options)
            .map(objects => objects.map(object => new DefaultTask(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/default-task/default-task.api-facade.ts